import {Reducer} from 'redux'
import {DocumentsActionTypes, DocumentsState} from './types';
import DocumentsService from "../../services/DocumentsService";
// import DocumentsService from "../../services/DocumentsService";

// Type-safe initialState!
const initialState: DocumentsState = {
	list: [],
	indexingList: [],
	indexingNumber: ''
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<DocumentsState> = (state = initialState, action) => {
	switch (action.type) {
		case DocumentsActionTypes.FETCH_ALL_REQUEST: {
			DocumentsService.getAllIndexed()
			return { ...state, loading: true }
		}
		case DocumentsActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case DocumentsActionTypes.FETCH_INDEXING_ALL_REQUEST: {
			DocumentsService.getAllForIndexing()
			return { ...state, loading: true }
		}
		case DocumentsActionTypes.FETCH_INDEXING_ALL_COMPLETED: {
			return { ...state, loading: false, indexingList: action.payload}
		}
		case DocumentsActionTypes.FETCH_ONE_REQUEST: {
			DocumentsService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case DocumentsActionTypes.FETCH_ONE_COMPLETED: {
			// updates list but I do not see usage of this at the moment
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case DocumentsActionTypes.SAVE_REQUEST: {
			DocumentsService.save(action.payload)
			return { ...state, loading: true }
		}
		case DocumentsActionTypes.SAVE_COMPLETED: {
			console.log(action.payload)
			return { ...state, loading: false}
		}
		case DocumentsActionTypes.DELETE_REQUEST: {
			DocumentsService.delete(action.payload)
			return { ...state, loading: true }
		}
		case DocumentsActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case DocumentsActionTypes.DELETE_MULTIPLE_REQUEST: {
			DocumentsService.deleteMultiple(action.payload.documents, action.payload.unindexed)
			return { ...state, loading: true }
		}
		case DocumentsActionTypes.DELETE_MULTIPLE_COMPLETED: {
			if (!action.payload.unindexed) {
				action.payload.documents.forEach((item: any) => {
					let foundIndex = state.list.findIndex(element => element.id === item.id)
					state.list.splice(foundIndex, 1)
				});
				let newList = [...state.list]

				return {...state, loading: false, list: newList}
			} else {
				action.payload.documents.forEach((item: any) => {
					let foundIndex = state.indexingList.findIndex(element => element.id === item.id)
					state.indexingList.splice(foundIndex, 1)
				});
				let newList = [...state.indexingList]

				return {...state, loading: false, indexingList: newList}
			}
		}
		case DocumentsActionTypes.PERFORM_ACTION_REQUEST: {
			DocumentsService.performAction(action.payload.action, action.payload.document)
			return { ...state, loading: true }
		}
		case DocumentsActionTypes.INDEXING_NUMBER_REQUEST: {
			DocumentsService.getIndexingNumber()
			return { ...state, loading: true }
		}
		case DocumentsActionTypes.INDEXING_NUMBER_COMPLETED: {
			return { ...state, loading: false, indexingNumber: action.payload }
		}
		case DocumentsActionTypes.PERFORM_ACTION_COMPLETED: {
			return { ...state, loading: false }
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export { reducer as DocumentsReducer }
